import React from 'react'
import { useMoteTranscriptTranslateMutation } from '@mote/api'
import {
  TRACK_EVENT_NAMES,
  TRANSLATION_LANGUAGES
} from '@mote/helpers/constants'
import { useMotePlayer } from '../../shared/contexts/motePlayer.context'

const Comparator = (a, b) => {
  if (a[1] < b[1]) return -1
  if (a[1] > b[1]) return 1
  return 0
}

const TRANSLATIONS = TRANSLATION_LANGUAGES.sort(Comparator)

export const useTranscriptTranslation = (moteId, isCreator, callback) => {
  const { handleTracking } = useMotePlayer()
  const { mutate: translate } = useMoteTranscriptTranslateMutation()

  const handleSelection = value => {
    translate({
      variables: {
        moteId,
        translationLanguage: value
      }
    })
      .then(res => {
        if (res.error) return

        handleTracking(TRACK_EVENT_NAMES.mote.action.translation, {
          languageCode: value,
          generatedBy: isCreator ? 'creator' : 'recipient'
        })

        callback(res.data.outputText)
      })
      .catch(console.error)
  }

  return { translations: TRANSLATIONS, translate: handleSelection }
}
